const Sdata=[
    {
         tey: 0,
        heading:"Elearning",
        websites: [
            {
                key:1,
        imgsrc:"https://lh3.googleusercontent.com/_axBDN8aKOieaLCs9VdKSdr1-MGWkrZQGazYBMLaLLazyliubH2DUAfd72eoYzD0MDQ=w512",
         title:"w3Schools",
        sname:"LearnHub",
        link:"https://www.w3schools.com/",
        },
        {
           key:2,
        imgsrc:"https://d3l9a8mvoa6cl8.cloudfront.net/wp-content/uploads/sites/3/2022/07/23203406/How-Does-Coursera-Work.jpg",
        title:"Coursera",
        sname:"LearnHub",
        link:"https://www.coursera.org/",
    },
    {
         key:3,
        imgsrc:"https://img-b.udemycdn.com/course/750x422/4077322_a979_4.jpg",
        title:"Udemy",
        sname:"LearnHub",
        link:"https://www.udemy.com/"  ,
        },
        {
            key:4,
            imgsrc:"https://8f430952.rocketcdn.me/wp-content/uploads/2021/07/edX-sold-MIT-and-Harvard.jpg",
             title:"EDX",
             sname:"LearnHub",
             link:"https://www.edx.org/",

        },
        {
             key:5,
            imgsrc:"https://talkstar-photos.s3.amazonaws.com/uploads/be6aba2a-9447-45e7-bdf3-ef087f455963/MollyWright_2021-embed.jpg",
            title:"TedEd",
            sname:"LearnHub",
            link:"https://ed.ted.com/",
           },
        ],
    },
        {
           
        tey:2,
       heading:"News",
       websites:[
        {
            key:5,
            imgsrc:"https://ichef.bbci.co.uk/images/ic/1200x675/p0g6j1tq.jpg",
            title:"BBC",
            sname:"DailyDose",
            link:"https://www.bbc.com/news",
        },
        {
            key:7,
            imgsrc:"https://gumlet.assettype.com/afaqs%2F2023-04%2F04999377-5da6-48c0-a191-8b299afdaff5%2FTOI_banner_Afaqs.jpg?rect=0%2C0%2C1920%2C1080&format=webp&w=400&dpr=2.6",
             title:"The Time",
             sname:"DailyDose",
             link:"https://time.com/",
        },
        {
            key:8,
            imgsrc:"https://sprtsecureassets.akamaized.net/operations/slates/nbcnews_20.jpg",
            title:"NBC",
              sname:"DailyDose",
              link:"https://www.nbcnews.com/",
        },
        {   
            key:9,
            imgsrc:"https://www.cnn.com/.element/interactive/2023/08/cnn-primetime-lineup.jpg",
            title:"CNN",
            sname:"DailyDose",
            link:"https://edition.cnn.com/",
        },
        {
            key:10,
            imgsrc:"https://i.ndtvimg.com/i/2016-11/ndtv-india-logo_650x400_71478247761.jpg",
            title:"NDTV",
            sname:"DailyDose",
            link:"https://www.ndtv.com/",
        },
        ],
    },
        {
            tey:3,
            heading:"OTT Streaming ",
            websites:[
                {
                    key:10,
                    imgsrc:"https://www.cnet.com/a/img/resize/b3d77540535b980192421ac4d1aa5687dc1d1eaa/hub/2022/10/03/10a0d96d-1b0b-4f8f-ba3b-b893d21edb65/prime-video.jpg?auto=webp&fit=crop&height=675&width=1200",
                    title:"Amazon prime vedio",
                    sname:"Entertainment",
                    link:"https://www.primevideo.com/offers/nonprimehomepage/ref=dv_web_force_root",
                },
                {
                    key:11,
                    imgsrc:"https://cdn.whats-on-netflix.com/wp-content/uploads/2023/02/04142711/renewed-netflix-shows-2023-beyond-jpg.webp",
                    title:"Netflix",
                    sname:"Entertainment",
                    link:"https://www.netflix.com/browse",
                },
                {
                    key:12,
                    imgsrc:"https://www.medianews4u.com/wp-content/uploads/2023/11/ZEE5-brightens-this-Diwali-with-Manoranjan-Festival-and-special-discount-offers-on-premium-subscriptions-.jpg",
                    title:"Zee5",
                    sname:"Entertainment",
                    link:"https://www.zee5.com/",
                },
                {
                    key:12,
                    imgsrc:"https://wallpapercave.com/dwp1x/wp9715882.jpg",
                    title:"Hotstar",
                    sname:"Entertainment",
                    link:"https://www.hotstar.com/in/home?ref=%2Fin",
                },
                {
                    key:13,
                    imgsrc:"https://www.streamingrant.com/wp-content/uploads/2022/07/SR-Best-Movies-on-Sonyliv-1.jpg",
                    title:"Sonylive",
                    sname:"Entertaiment",
                    link:"https://www.sonyliv.com/",
                },
                {
                    key:15,
                    imgsrc:"https://etimg.etb2bimg.com/photo/88723582.cms",
                    title:"HBOmax",
                    sname:"Entertaiment",
                    link:"https://www.hbomax.com/geo-availability"
                }
                
            ],
        },
                {
                    tey:4,
                    heading:"Ecommerce and clothes website  ",
                    websites:[
                        {
                            key:13,
                           imgsrc:"https://play-lh.googleusercontent.com/YUWVdQyOt_NPjh4UMdYkSwgYY23yTO4H9Nv1OdQebALmufKPWsq30F48OhbrTeNj3dE=w720-h405-rw",
                              title:"Flipkart",
                              sname:"CartRush",       
                              link:"https://www.flipkart.com/",             
                        },
                       {
                        key:14,
                        imgsrc:"https://i.pcmag.com/imagery/articles/05qp7E8Z6G2lM79Y6Epl0tl-11..v1660159907.jpg",
                        title:"Amazon",
                        sname:"CartRush",
                        link:"https://www.amazon.in/",
                       },
                       {
                        key:15,
                        imgsrc:"https://media.fashionnetwork.com/cdn-cgi/image/fit=contain,width=1000,height=1000/m/4e82/1564/0d39/6b36/2c9e/92c8/9f9b/be77/77de/a592/a592.jpeg",
                        title:"Myntra",
                        sname:"FashionFusion",
                        link:"https://www.myntra.com/",
     },
     {
        key:16,
                    imgsrc:"https://www.qwikcilver.com/wp-content/uploads/Reliance-Ajio-a.jpg",
                    title:"Ajio",
                    sname:"FashionFusion",
                    link:"https://www.ajio.com/",
                    
     },               {
        key:17,
                       imgsrc:"https://www.tofler.in/blog/wp-content/uploads/2023/06/4-Nykaa-launches-The-Global-Store-to-offer-International-beauty-skincare-brands-in-India.jpg",
                       title:"Nykaa",
                       sname:"FashionBeauty",
                       link:"https://www.nykaa.com/",
                       },
                       {
                        key:18,
                        imgsrc:"https://stockarea.io/blogs/wp-content/uploads/2021/05/sonder-quest-5ze1ouvzSM8-unsplash-1024x679.jpg",
                        title:"Indain mart",
                        sname:"India's Finest Bazaar",
                        link:"https://www.indiamart.com/",
                       }
    
                     
                    ]
                },
    
    
            
        
    ];
    export default Sdata;